(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  onReady(() => {
    const body = document.body;
    if (!body || !body.classList.contains('dtc-partner')) return;

    body.classList.add('db2-ready');

    document.addEventListener('click', (event) => {
      const menuClose = event.target.closest('#MenuDrawer .db2-mobile-drawer-close, #MenuDrawer .drawer__close');
      if (menuClose) {
        const menuDrawer = document.getElementById('MenuDrawer');
        if (typeof menuDrawer?.hide === 'function') menuDrawer.hide();
      }

      const searchClose = event.target.closest('#SearchDrawer .db2-search-drawer-close');
      if (searchClose) {
        const searchDrawer = document.getElementById('SearchDrawer');
        if (typeof searchDrawer?.hide === 'function') searchDrawer.hide();
      }

      const cartClose = event.target.closest('#CartDrawer .db2-cart-drawer-close');
      if (cartClose) {
        const cartDrawer = document.getElementById('CartDrawer');
        if (typeof cartDrawer?.hide === 'function') cartDrawer.hide();
      }

      const trigger = event.target.closest('[data-db2-klaviyo-form]');
      if (trigger) {
        event.preventDefault();
        const formId = trigger.getAttribute('data-db2-klaviyo-form');
        const fallbackUrl = trigger.getAttribute('href');
        const klaviyoLoaded = () => !!document.querySelector('script[src*="static.klaviyo.com/onsite/js"]') && (typeof window.klaviyo !== 'undefined' || typeof window._learnq !== 'undefined');
        const formVisible = () => Array.from(document.querySelectorAll('form.klaviyo-form, [data-testid="klaviyo-form"]')).some((form) => form.offsetWidth > 0 && form.offsetHeight > 0);
        if (formId) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        }
        // Fallback: if Klaviyo is blocked or the form never appears, go to the signup page instead of doing nothing.
        if (fallbackUrl && fallbackUrl !== '#') {
          const startedAt = Date.now();
          const check = () => {
            if (formVisible()) return;
            if (!klaviyoLoaded() || Date.now() - startedAt >= 1500) {
              window.location.assign(fallbackUrl);
              return;
            }
            window.setTimeout(check, 250);
          };
          window.setTimeout(check, klaviyoLoaded() ? 600 : 250);
        }
      }

      if (!event.target.closest('.db2-nav details')) {
        document.querySelectorAll('.db2-nav details[open]').forEach((details) => details.removeAttribute('open'));
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.db2-nav details[open]').forEach((details) => details.removeAttribute('open'));
    });

    document.querySelectorAll('[data-db2-localization]').forEach((select) => {
      select.addEventListener('change', () => select.form?.submit());
    });

    const header = document.querySelector('[data-db2-header]');
    if (header) {
      const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }
  });
})();
